import { dateformat } from '../../../helpers';
import { CLEAR_ALL, LOGOUT } from '../../../store/Types';

export const ALL_RECIBOS = 'ALL_RECIBOS';
export const ACTIVO_RECIBOS = 'ACTIVO_RECIBOS';
export const LOADING_ALL_RECIBOS = 'LOADING_ALL_RECIBOS';
export const PARAMS_RECIBOS = 'PARAMS_RECIBOS';
export const SECCION_RECIBOS = 'SECCION_RECIBOS';
export const ESTADISTICAS_RECIBOS = 'ESTADISTICAS_RECIBOS';
export const PARAMS_ESTADISTICAS_RECIBOS = 'PARAMS_ESTADISTICAS_RECIBOS';

const initialState = {
  all: [],
  loadingAll: false,
  activo: null,
  idSeccion: null,
  pagination: {
    currentPage: 1,
    itemCount: 1,
    itemsPerPage: 50,
    totalItems: 1,
    totalPages: 1,
  },
  params: {
    idEntidad: null,
    idSeccion: null,
    idEstatus: null,
    q: null,
    orders: null,
    desde: dateformat(null, {}),
    hasta: dateformat(null, {}),
    page: 1,
    limit: 50,
  },
  estadisticas: null,
  paramsEstadisticas: {
    idEntidad: null,
    idSeccion: null,
    idFamiliar: null,
  },
};

export const recibosReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_RECIBOS:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        pagination: action.payload.meta,
      };
    case ACTIVO_RECIBOS:
      return {
        ...state,
        activo: action.payload,
      };
    case SECCION_RECIBOS:
      return {
        ...state,
        idSeccion: action.payload,
      };
    case LOADING_ALL_RECIBOS:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case PARAMS_RECIBOS:
      return {
        ...state,
        params: action.payload,
      };
    case ESTADISTICAS_RECIBOS:
      return {
        ...state,
        estadisticas: action.payload,
      };
    case PARAMS_ESTADISTICAS_RECIBOS:
      return {
        ...state,
        paramsEstadisticas: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
